import { Suspense } from "react";
import { Helmet } from "react-helmet";
import { Redirect, Route, Switch } from "react-router-dom";
import routes from "src/configs/routes";

export default function RouteApp() {
  return (
    <Switch>
      {routes.map((route) => (
        <Route
          key={route.path}
          path={route.path}
          exact={route.exact}
          render={(props) => (
            <Suspense fallback={null}>
              <Helmet>
                <meta property="og:url" content={window.location.href} />
                <meta name="twitter:url" content={window.location.href} />
              </Helmet>
              <route.component {...props} />
            </Suspense>
          )}
        />
      ))}
      <Route path="*">
        <Redirect to="/marketplace/sell-order" />
      </Route>
    </Switch>
  );
}
